import React, { useEffect, useRef } from 'react';

import * as echarts from 'echarts/core';
import {
  TooltipComponent,
  TooltipComponentOption,
  GridComponent,
  GridComponentOption,
  TitleComponent,
  TitleComponentOption,
  DataZoomComponent,
  DataZoomComponentOption,
  ToolboxComponent,
  ToolboxComponentOption,
  LegendComponent,
  LegendComponentOption,
} from 'echarts/components';
import { LineChart, LineSeriesOption } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import { debounce } from 'lodash';
import HistoryWorker from './history.worker';

echarts.use([TitleComponent, ToolboxComponent, TooltipComponent, LegendComponent, GridComponent, DataZoomComponent, LineChart, CanvasRenderer, UniversalTransition]);

export type EChartsOption = echarts.ComposeOption<
  TitleComponentOption | ToolboxComponentOption | TooltipComponentOption | LegendComponentOption | GridComponentOption | DataZoomComponentOption | LineSeriesOption
>;

const Line = ({ options }: { options: EChartsOption }) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const echartsRef = useRef<echarts.ECharts>(null);
  const worker = useRef<Worker>();
  // const isInitialRef = useRef<boolean>(true);

  useEffect(() => {
    // console.log('init');
    worker.current = new HistoryWorker();
    const resizeFun = () => {
      echartsRef.current?.resize();
    };
    window.addEventListener('resize', debounce(resizeFun, 1000));
    return () => {
      window.removeEventListener('resize', resizeFun);
      worker.current?.terminate?.();
    };
  }, []);

  const loadChart = () => {
    if (!echartsRef.current) {
      // @ts-ignore
      echartsRef.current = echarts.init(chartRef.current, null, {
        renderer: 'canvas',
        devicePixelRatio: 2,
      });
    }
    echartsRef.current?.setOption(options, true);
    // worker.current?.postMessage(data);
    // // @ts-ignore
    // worker.current.onmessage = ({ data: options }: { data: EChartsOption }) => {
    //   echartsRef.current?.setOption(options);
    // };
    // echartsRef.current.setOption(
    //   {
    //     legend: {
    //       orient: 'horizontal',
    //       top: 'top',
    //       left: 'center',
    //     },
    //     tooltip: {
    //       trigger: 'axis',
    //       textStyle: {
    //         fontSize: 12,
    //         color: '#262626',
    //         lineHeight: 18,
    //       },
    //       borderRadius: 4,
    //       borderWidth: 1,
    //       padding: 16,
    //       extraCssText: 'box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.1),0px 0px 24px 0px rgba(0, 0, 0, 0.15);',

    //       formatter: (items: CallbackDataParams[]) => {
    //         // console.log({ items });
    //         // const { name, value, color } = item;
    //         return `<div ><div style="font-size:14px;font-weight:500;margin-bottom:10px">${items[0].name}</div>${items
    //           .map(
    //             ({ value, color, seriesName }) => `<div style="display:flex;justify-content:space-between;min-width:160px;font-size:12px;line-height:18px;align-items:center;">
    //         <div style="color:#262626;display:flex;margin-right:20px;align-items:center;line-height:18px"><span style="background:${color};width:12px;height:12px;margin-right:8px;display:block;"></span><span style="display:block">${seriesName}</span></div><span style="color:#000;font-weight:500;display:block">${value}</span></div>`,
    //           )
    //           .join('')}</div>`;
    //       },
    //     },
    //     grid: {
    //       left: 0,
    //       right: 10,
    //       containLabel: true,
    //     },

    //     yAxis: [
    //       {
    //         type: 'value',
    //         splitLine: {
    //           lineStyle: {
    //             type: 'dashed',
    //             color: '#E5E5E5',
    //           },
    //         },
    //       },
    //     ],
    //     dataZoom: [
    //       {
    //         show: true,
    //         type: 'slider',
    //         start: 0,
    //         end: 10,
    //         height: 20,
    //       },
    //     ],
    //     series: data?.map((item) => ({
    //       type: 'line',
    //       name: `${item.device_name}/${item.name}`,

    //       data: item.report_data?.map((report) => report.value),
    //       sampling: 'average',
    //       label: { show: false },
    //     })),
    //     // xAxis: {
    //     //   data: data?.[0]?.report_data?.map((item) => dayjs(item.time).format('YYYY-MM-DD HH:mm:ss')) || [],
    //     // },
    //     xAxis: [
    //       {
    //         type: 'category',
    //         data: data?.[0]?.report_data?.map((item) => dayjs(item.time).format('YYYY-MM-DD HH:mm:ss')) || [],
    //         axisTick: {
    //           alignWithLabel: true,
    //         },
    //         nameTextStyle: {
    //           color: '#7F7F7F',
    //           borderColor: '#000',
    //         },
    //         axisLabel: {
    //           interval: 0,
    //           show: false,
    //         },
    //       },
    //     ],
    //   } as EChartsOption,
    //   true,
    // );
  };

  useEffect(() => {
    loadChart();
  }, [options]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: '24px',
        borderRadius: '8px',
        border: '1px solid #CCCCCC',
      }}
    >
      <div ref={chartRef} style={{ width: '100%', flex: 1 }}></div>
    </div>
  );
};
export default Line;
